import React from "react";

type CardGripProps = {
  children?: React.ReactNode;
};
const CardGrid = ({ children }: CardGripProps) => {
  return (
    <ul role="list" className="grid grid-cols-1 gap-x-6 gap-y-8 lg:grid-cols-2 xl:gap-x-8">
      {children}
    </ul>
  );
};

export default CardGrid;
